import React, { useMemo } from "react";
import ReceiptLongRoundedIcon from "@mui/icons-material/ReceiptLongRounded";
import DrawRoundedIcon from "@mui/icons-material/DrawRounded";
import PendingActionsRoundedIcon from "@mui/icons-material/PendingActionsRounded";
import VerifiedRoundedIcon from "@mui/icons-material/VerifiedRounded";
import classes from "./charts.module.css";
import { useSelector } from "react-redux";
import { useMerchantInvoiceDashboardOffline } from "../../../../offline";
import { formatCompactNumber } from "./chartPeriodUtils";

const CountCards = () => {
  const Data = useSelector((state) => state.loginData.value);
  const auth_token = Data?.auth_token;
  const user_token = Data?.user?.token || Data?.user_token;
  const org_id = Data?.org_id || Data?.user?.org_id || Data?.organization_id;

  const { data: dashboardSummary } = useMerchantInvoiceDashboardOffline(
    auth_token,
    user_token,
    org_id
  );

  const invoiceData = dashboardSummary?.invoice_card_count || {};
  const totalInvoices = Number(invoiceData?.total || 0);

  const cards = useMemo(
    () => [
      {
        title: "Total Invoices",
        value: totalInvoices,
        meta: "All merchant payment claims",
        badge: "Live overview",
        tone: "toneOcean",
        Icon: ReceiptLongRoundedIcon,
      },
      {
        title: "E-Signed",
        value: Number(invoiceData?.signed || 0),
        meta: "Completed merchant sign-off",
        badge: totalInvoices
          ? `${Math.round((Number(invoiceData?.signed || 0) / totalInvoices) * 100)}% of total`
          : "0% of total",
        tone: "toneEmerald",
        Icon: DrawRoundedIcon,
      },
      {
        title: "Awaiting E-Signature",
        value: Number(invoiceData?.unsigned || 0),
        meta: "Needs merchant attention",
        badge: totalInvoices
          ? `${Math.round((Number(invoiceData?.unsigned || 0) / totalInvoices) * 100)}% awaiting`
          : "No pending claims",
        tone: "toneAmber",
        Icon: PendingActionsRoundedIcon,
      },
      {
        title: "Approved",
        value: Number(invoiceData?.approved || 0),
        meta: "Ready for downstream payment actions",
        badge: totalInvoices
          ? `${Math.round((Number(invoiceData?.approved || 0) / totalInvoices) * 100)}% cleared`
          : "No approvals yet",
        tone: "toneIndigo",
        Icon: VerifiedRoundedIcon,
      },
    ],
    [invoiceData, totalInvoices]
  );

  return (
    <div className={classes.cardscontainer}>
      {cards.map(({ Icon, title, value, meta, badge, tone }) => (
        <article key={title} className={`${classes.card} ${classes[tone]}`}>
          <div className={classes.cardTopRow}>
            <div>
              <p className={classes.cardEyebrow}>{title}</p>
              <div className={classes.cardvalue}>{formatCompactNumber(value)}</div>
            </div>
            <span className={classes.cardIconWrap}>
              <Icon fontSize="inherit" />
            </span>
          </div>

          <div className={classes.cardBottomRow}>
            <p className={classes.cardMeta}>{meta}</p>
            <span className={classes.cardBadge}>{badge}</span>
          </div>
        </article>
      ))}
    </div>
  );
};

export default CountCards;
